import { jsxs as e, jsx as t } from "react/jsx-runtime";
import { VisuallyHidden as p } from "../../VisuallyHidden/VisuallyHidden.js";
import l from "../../../utils/colors.js";
import { ItemContainer as o, IconWrapper as a, CompletedStepWrapper as c, TextWrapper as s } from "./styled.js";
function u({ index: i, name: n, mode: r }) {
  return /* @__PURE__ */ e(o, { children: [
    /* @__PURE__ */ e(a, { mode: r, children: [
      " ",
      r === "Past" ? /* @__PURE__ */ t(c, { fill: l.white }) : i + 1
    ] }),
    /* @__PURE__ */ e(s, { mode: r, children: [
      n,
      r === "Past" && /* @__PURE__ */ t(p, { children: " - Step completed" }),
      r === "Current" && /* @__PURE__ */ t(p, { children: " - Current step" })
    ] })
  ] });
}
export {
  u as default
};
